/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
class o{constructor(o,s,t){this.row=o,this.colFrom=s,this.colTo=t}}export{o as default};
